import { SectionTitle } from "../ProfileSection/ProfileSection.styles";
import BookingListFinished from "../BookingListFinished/BookingListFinished";



const SectionHistory = () => {
    return(
        <>
            <SectionTitle>Citas Finalizadas</SectionTitle>
            <BookingListFinished />
        </>
    )
}

export default SectionHistory;